export default __webpack_public_path__ + "static/media/arrow-right.09f999ee.svg";